export default "__VITE_ASSET__7076a132__"